import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import { GreyPallet } from "../../../config/styles";

export const CustomButton = styled(IconButton)({
  borderWidth: "3px",
  borderColor: `${GreyPallet.LightGhost}`,
  borderStyle: "solid",
});
